import React from "react";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import { ModalAlert } from "../../common/dialog/modalAlert";
import solVerde from "../../assets/images/solVerde.png";
import solVermelho from "../../assets/images/solVermelho.png";

export function ModalFiltrosFaturasAdmEnergia(props) {
    if (!props.visible) return null;

    function getStyleSlimCard(bgColor, textColor) {
        return {
            borderRadius: 8,
            cursor: "pointer",
            backgroundColor: bgColor,
            color: textColor || "#000000",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px 10px 0px 10px",
            width: "100%",
            minHeight: "40px",
            margin: 5,
            boxShadow: "#9b9b9b 0px 1px 2px 1px",
        };
    }

    return (
        <ModalAlert titulo="Filtrar Faturas" handleClose={props.handleClose}>
            <Row style={{ padding: 7, marginTop: 10 }}>
                <b>ERROS - Situação que pode bloquear fatura para download do cliente</b>
            </Row>
            <Row style={{ padding: 7 }}>
                {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                    <>
                        <Grid
                            cols="12 12 12 6"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                cursor: "pointer",
                            }}
                        >
                            <label style={getStyleSlimCard("#6dc9ff")} htmlFor="filtro-todas">
                                <LabelAndCheckbox
                                    style={{ justifyContent: "center" }}
                                    readOnly={props.aguardando}
                                    modoCard={true}
                                    colorIcon="#000"
                                    id="filtro-todas"
                                    label={`Todas as faturas (${
                                        props.quantidadesFiltro.qtdCorBranca +
                                        props.quantidadesFiltro.qtdCorAmarela +
                                        props.quantidadesFiltro.qtdCorAzul +
                                        props.quantidadesFiltro.qtdCorVerde +
                                        props.quantidadesFiltro.qtdCorVermelha
                                    })`}
                                    onChange={(e) =>
                                        props.setState({
                                            ...props.filtroState,
                                            statusCorBranca: e.target.checked,
                                            statusCorAzul: e.target.checked,
                                            statusCorAmarela: e.target.checked,
                                            statusCorVermelha: e.target.checked,
                                            statusCorVerde: e.target.checked,
                                            statusImportacaoSolarVerde: false,
                                            statusImportacaoSolarVermelha: false,
                                        })
                                    }
                                    value={
                                        props.filtroState.statusCorBranca &&
                                        props.filtroState.statusCorAzul &&
                                        props.filtroState.statusCorAmarela &&
                                        props.filtroState.statusCorVermelha &&
                                        props.filtroState.statusCorVerde &&
                                        !props.filtroState.statusImportacaoSolarVerde &&
                                        !props.filtroState.statusImportacaoSolarVermelha
                                    }
                                />
                            </label>
                        </Grid>
                        <Grid
                            cols="12 12 12 6"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <label style={getStyleSlimCard("#FFEF71")} htmlFor="filtro-amarelas">
                                <LabelAndCheckbox
                                    style={{ justifyContent: "center" }}
                                    readOnly={props.aguardando}
                                    modoCard={true}
                                    colorIcon="#000"
                                    id="filtro-amarelas"
                                    label={`Faturas corrigidas (${props.quantidadesFiltro.qtdCorAmarela})`}
                                    onChange={(e) =>
                                        props.setState({
                                            ...props.filtroState,
                                            statusCorAmarela: e.target.checked,
                                        })
                                    }
                                    value={!!props.filtroState.statusCorAmarela}
                                />
                            </label>
                        </Grid>

                        <Grid
                            cols="12 12 12 6"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <label style={getStyleSlimCard("#FF6569")} htmlFor="filtro-vermelhas">
                                <LabelAndCheckbox
                                    style={{ justifyContent: "center" }}
                                    readOnly={props.aguardando}
                                    modoCard={true}
                                    colorIcon="#000"
                                    id="filtro-vermelhas"
                                    label={`Faturas com necessidade de correção (${props.quantidadesFiltro.qtdCorVermelha})`}
                                    onChange={(e) =>
                                        props.setState({
                                            ...props.filtroState,
                                            statusCorVermelha: e.target.checked,
                                        })
                                    }
                                    value={!!props.filtroState.statusCorVermelha}
                                />
                            </label>
                        </Grid>

                        <Grid
                            cols="12 12 12 6"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <label style={getStyleSlimCard("#44FFAA")} htmlFor="filtro-verdes">
                                <LabelAndCheckbox
                                    style={{ justifyContent: "center" }}
                                    readOnly={props.aguardando}
                                    modoCard={true}
                                    colorIcon="#000"
                                    id="filtro-verdes"
                                    label={`Faturas validadas e sem erros (${props.quantidadesFiltro.qtdCorVerde})`}
                                    onChange={(e) => props.setState({ ...props.filtroState, statusCorVerde: e.target.checked })}
                                    value={!!props.filtroState.statusCorVerde}
                                />
                            </label>
                        </Grid>
                        <Grid
                            cols="12 12 12 6"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                cursor: "pointer",
                            }}
                        >
                            <label style={getStyleSlimCard("#f9f9f9")} htmlFor="filtro-brancas">
                                <LabelAndCheckbox
                                    style={{ justifyContent: "center" }}
                                    readOnly={props.aguardando}
                                    modoCard={true}
                                    colorIcon="#000"
                                    id="filtro-brancas"
                                    label={`Faturas não importadas (${props.quantidadesFiltro.qtdCorBranca})`}
                                    onChange={(e) =>
                                        props.setState({
                                            ...props.filtroState,
                                            statusCorBranca: e.target.checked,
                                        })
                                    }
                                    value={!!props.filtroState.statusCorBranca}
                                />
                            </label>
                        </Grid>
                        <Grid
                            cols="12 12 12 6"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <label style={getStyleSlimCard("#C5FFFF")} htmlFor="filtro-azuis">
                                <LabelAndCheckbox
                                    style={{ justifyContent: "center" }}
                                    readOnly={props.aguardando}
                                    modoCard={true}
                                    colorIcon="#000"
                                    id="filtro-azuis"
                                    label={`Faturas isentas (${props.quantidadesFiltro.qtdCorAzul})`}
                                    onChange={(e) =>
                                        props.setState({
                                            ...props.filtroState,
                                            statusCorAzul: e.target.checked,
                                        })
                                    }
                                    value={!!props.filtroState.statusCorAzul}
                                />
                            </label>
                        </Grid>
                    </>
                ) : null}
            </Row>
            <Row style={{ padding: 7, marginTop: 10 }}>
                <b>ALERTAS - Situação que não bloqueia fatura para o cliente</b>
            </Row>
            <Row style={{ padding: 7 }}>
                <Grid cols="12 12 12 12" style={{ display: "flex", justifyContent: "center" }}>
                    <label style={getStyleSlimCard("#ff434d", "#101010")} htmlFor="filtro-download-atrasado">
                        <LabelAndCheckbox
                            style={{ justifyContent: "center" }}
                            readOnly={props.aguardando}
                            modoCard={true}
                            colorIcon="#101010"
                            id="filtro-download-atrasado"
                            label={`Apenas Downloads Atrasados (${props.quantidadesFiltro.qtdUnidadesDownloadAtrasado})`}
                            onChange={(e) =>
                                props.setState({
                                    ...props.filtroState,
                                    apenasDownloadAtrasado: e.target.checked,
                                })
                            }
                            value={!!props.filtroState.apenasDownloadAtrasado}
                        />
                    </label>
                </Grid>

                <Grid cols="12 12 12 6" style={{ display: "flex", justifyContent: "center" }}>
                    <label style={getStyleSlimCard("#c3151a", "#FEFEFE")} htmlFor="filtro-alertas">
                        <LabelAndCheckbox
                            style={{ justifyContent: "center" }}
                            readOnly={props.aguardando}
                            modoCard={true}
                            colorIcon="#ffffff"
                            id="filtro-alertas"
                            label={`Alertas - Necessário Revisar (${props.quantidadesFiltro.qtdCorVermelhaAlertas})`}
                            onChange={(e) =>
                                props.setState({
                                    ...props.filtroState,
                                    apenasAlertas: e.target.checked,
                                    apenasAlertasVerificados: false,
                                })
                            }
                            value={!!props.filtroState.apenasAlertas}
                        />
                    </label>
                </Grid>
                <Grid cols="12 12 12 6" style={{ display: "flex", justifyContent: "center" }}>
                    <label style={getStyleSlimCard("#136337", "#FEFEFE")} htmlFor="filtro-alertas-verificados">
                        <LabelAndCheckbox
                            style={{ justifyContent: "center" }}
                            readOnly={props.aguardando}
                            modoCard={true}
                            colorIcon="#ffffff"
                            id="filtro-alertas-verificados"
                            label={`Alertas - Apenas Revisados`}
                            onChange={(e) =>
                                props.setState({
                                    ...props.filtroState,
                                    apenasAlertasVerificados: e.target.checked,
                                    apenasAlertas: false,
                                })
                            }
                            value={!!props.filtroState.apenasAlertasVerificados}
                        />
                    </label>
                </Grid>
            </Row>
            <Row style={{ padding: 7, marginTop: 10 }}>
                <b>FILTROS GERAIS</b>
            </Row>
            <Row style={{ padding: 7 }}>
                <Grid cols="12 12 12 6" style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}>
                    <label style={getStyleSlimCard("#257bfb", "#FFFFFF")} htmlFor="filtro-apenas-implantacao">
                        <LabelAndCheckbox
                            style={{ justifyContent: "center" }}
                            readOnly={props.aguardando}
                            modoCard={true}
                            colorIcon="#FFF"
                            id="filtro-apenas-implantacao"
                            label={`Apenas Unidades em Implantação (${props.quantidadesFiltro.qtdUnidadesEmImplantacao})`}
                            onChange={(e) =>
                                props.setState({
                                    ...props.filtroState,
                                    apenasUnidadesEmImplantacao: !props.filtroState.apenasUnidadesEmImplantacao,
                                })
                            }
                            value={!!props.filtroState.apenasUnidadesEmImplantacao}
                        />
                    </label>
                </Grid>
                <Grid cols="12 12 12 6" style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}>
                    <label style={getStyleSlimCard("#ffa348", "#000000")} htmlFor="filtro-apenas-item-sem-tipo">
                        <LabelAndCheckbox
                            style={{ justifyContent: "center" }}
                            readOnly={props.aguardando}
                            modoCard={true}
                            colorIcon="#000"
                            id="filtro-apenas-item-sem-tipo"
                            label={`Apenas faturas com itens sem tipo (${props.quantidadesFiltro.qtdFaturasItemSemTipo})`}
                            onChange={(e) =>
                                props.setState({
                                    ...props.filtroState,
                                    apenasFaturasItemSemTipo: !props.filtroState.apenasFaturasItemSemTipo,
                                })
                            }
                            value={!!props.filtroState.apenasFaturasItemSemTipo}
                        />
                    </label>
                </Grid>
                <Grid cols="12 12 12 6" style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}>
                    <label style={getStyleSlimCard("#53ff84", "#000000")} htmlFor="filtro-apenas-refaturadas">
                        <LabelAndCheckbox
                            style={{ justifyContent: "center" }}
                            readOnly={props.aguardando}
                            modoCard={true}
                            colorIcon="#000"
                            id="filtro-apenas-refaturadas"
                            label={`Apenas faturas refaturadas (${props.quantidadesFiltro.qtdFaturasRefaturadas})`}
                            onChange={(e) =>
                                props.setState({
                                    ...props.filtroState,
                                    apenasFaturasRefaturadas: !props.filtroState.apenasFaturasRefaturadas,
                                })
                            }
                            value={!!props.filtroState.apenasFaturasRefaturadas}
                        />
                    </label>
                </Grid>
                <Grid cols="12 12 12 6" style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}>
                    <label style={getStyleSlimCard("#FEFEFE", "#e63d3d")} htmlFor="filtro-apenas-m-livre-sem-despesas">
                        <LabelAndCheckbox
                            style={{ justifyContent: "center" }}
                            modoCard={true}
                            colorIcon="#000"
                            readOnly={props.aguardando}
                            id="filtro-apenas-m-livre-sem-despesas"
                            label={`Apenas faturas M. Livre sem despesas (${props.quantidadesFiltro.qtdMercadoLivreSemDespesas})`}
                            onChange={(e) =>
                                props.setState({
                                    ...props.filtroState,
                                    apenasMercadoLivreSemDespesas: !props.filtroState.apenasMercadoLivreSemDespesas,
                                })
                            }
                            value={!!props.filtroState.apenasMercadoLivreSemDespesas}
                        />
                    </label>
                </Grid>
            </Row>
            <Row style={{ padding: 7, marginTop: 10 }}>
                <b>SOLAR</b>
            </Row>
            <Row style={{ padding: 7 }}>
                <Grid
                    cols="12 12 12 6"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <label style={getStyleSlimCard("#2f2f2f", "#FFFFFF")} htmlFor="filtro-solar-importado" title="Solar Importado">
                        <LabelAndCheckbox
                            style={{ justifyContent: "center" }}
                            readOnly={props.aguardando}
                            modoCard={true}
                            colorIcon="#FFF"
                            id="filtro-solar-importado"
                            label={
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <img height={24} src={solVerde} alt=""></img>
                                    <span style={{ paddingLeft: 10 }}>Solar Importado ({props.quantidadesFiltro.qtdImportacaoSolarVerde})</span>
                                </div>
                            }
                            onChange={(e) => props.setState({ ...props.filtroState, statusImportacaoSolarVerde: e.target.checked })}
                            value={!!props.filtroState.statusImportacaoSolarVerde}
                        />
                    </label>
                </Grid>
                <Grid cols="12 12 12 6" style={{ display: "flex", justifyContent: "center" }}>
                    <label style={getStyleSlimCard("#2f2f2f", "#FFFFFF")} htmlFor="filtro-solar-nao-importado" title="Solar Não Importado">
                        <LabelAndCheckbox
                            style={{ justifyContent: "center" }}
                            readOnly={props.aguardando}
                            modoCard={true}
                            colorIcon="#FFF"
                            id="filtro-solar-nao-importado"
                            label={
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <img alt="" height={24} src={solVermelho}></img>
                                    <span style={{ paddingLeft: 10 }}>Solar Não Importado ({props.quantidadesFiltro.qtdImportacaoSolarVermelha})</span>
                                </div>
                            }
                            onChange={(e) => props.setState({ ...props.filtroState, statusImportacaoSolarVermelha: e.target.checked })}
                            value={!!props.filtroState.statusImportacaoSolarVermelha}
                        />
                    </label>
                </Grid>
            </Row>
        </ModalAlert>
    );
}
